import * as React from 'react';
import { Button, Header, Popup, Table } from 'semantic-ui-react';

import { clienteApi, Resultados } from 'src/api';
import { NombrePersonal } from 'src/componentes';
import { Contexto } from 'src/contexto';

interface State {
    readonly buscando: boolean;
    readonly procesosNulos: Resultados<'resumenesDeProcesosDeMatricula'>;
}

class Nulos extends React.Component<{}, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        buscando: false,
        procesosNulos: [],
    };

    public componentDidMount() {
        this.obtenerProcesosNulos();
    }

    public render() {
        const { buscando } = this.state;

        return (
            <div>
                <Header as='h1'>Procesos de matrícula nulos</Header>
                {buscando ? <p>Cargando...</p> : this.renderizarTabla()}
            </div>
        );
    }

    private renderizarTabla() {
        const { procesosNulos } = this.state;

        return (
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Nombre' />
                        <Table.HeaderCell content='Rut/Pasaporte' />
                        <Table.HeaderCell content='Nº de contrato' />
                        <Table.HeaderCell />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {procesosNulos.map(proceso => (
                        <Table.Row key={proceso.id}>
                            <Table.Cell
                                content={<NombrePersonal nombre={proceso.apoderado.nombre} />}
                            />
                            <Table.Cell content={proceso.apoderado.rutPasaporte.valor} />
                            <Table.Cell content={proceso.numerosDeContrato.join(', ')} />
                            <Table.Cell>
                                <Popup
                                    trigger={<Button content='Reestablecer' size='small' />}
                                    on='click'
                                    closeOnEscape
                                    hideOnScroll
                                    hoverable
                                >
                                    <Popup.Header content='Reestablecer el proceso' />
                                    <Popup.Content>
                                        <p>
                                            Las matrículas y el apoderado volverán a aparecer en la
                                            lista de planes de pago y dejará de considerarse nulo.
                                        </p>

                                        <p>¿Está seguro?</p>

                                        <Button
                                            content='Sí, reestablecer'
                                            primary
                                            onClick={() => {
                                                this.desanularProceso(proceso.apoderado.id);
                                            }}
                                        />
                                    </Popup.Content>
                                </Popup>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        );
    }

    private readonly desanularProceso = (idApoderado: string) => {
        this.setState({ buscando: true });

        clienteApi
            .ejecutar('desanularProcesoDeMatricula', { idApoderado })
            .then(() => this.obtenerProcesosNulos())
            .catch(error => {
                this.setState({ buscando: false });
                this.context.mostrarModalError(error);
            });
    };

    private readonly obtenerProcesosNulos = () => {
        this.setState({ buscando: true });

        clienteApi
            .ejecutar('resumenesDeProcesosDeMatricula', { tipo: 'nulas' })
            .then(procesosNulos => {
                this.setState({ buscando: false, procesosNulos });
            })
            .catch(error => {
                this.setState({ buscando: false });
                this.context.mostrarModalError(error);
            });
    };
}

export default Nulos;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Nulos/index.tsx